import {getDaysInMs, getHoursInMs, getMinutesInMs} from '../../util/date/index';

export const POLL_INTERVAL_MS = getMinutesInMs(30); // Check every 30 minutes
export const THRESHOLD_MS = getDaysInMs(2); // 2 days for initial alert
export const DISMISSED_THRESHOLD_MS = getHoursInMs(12); // 12 hours after dismiss
